($ => {
  $(document).ready(init);
  function init() {
    /* eslint-disable */
    window.setTimeout(() => {
      // TODO: Disable before production
     // new theme.classes.staticpages(); 
     //header
     if($(window).width() > 767){
        $('#SiteNavLabel-our-products').attr('style', 'height: '+ 600+'px;overflow-y: scroll;');

        $('body').on('click', function (event) {
          if (!$(event.target).closest('.desktopmenu').length || !$(event.target).closest('.site-nav--has-dropdown').length ) {
            if($(event.target).hasClass('site-nav__link') || $(event.target).hasClass('site-nav__label') || $(event.target).hasClass('icon-chevron-down') || $(event.target).hasClass('icon-chevron-up') || $(event.target).hasClass('desktopmenu') || $(event.target).hasClass('site-nav--has-dropdown')) {
  
            } else {
              $('.site-nav__dropdown').each(function(){
                if($(this).hasClass('active')){
                $(this).removeClass('active');
                }
              });
            }
          }
        });
        
     }
      
     $('.site-nav--has-dropdown').on('click', function(){
      let idToOpen = $(this).children('button').attr('aria-controls');
       $('.site-nav__dropdown').each(function(){
         if($(this).attr('id') == idToOpen) {
          $(this).toggleClass('active');
         } else {
         if($(this).hasClass('active')){
          $(this).removeClass('active');
         }
         }
       });
     });


     
     //header

     if ($(".bold-ro__bold-active input[name='bold-ro__selector_radio_button']").hasClass('bold-ro__subscribe-radio-btn')) {
      let inputQTY = "#Quantity-product-template";
      let valueQTY = $(inputQTY).val();
      let prodpricewithmoney = $('.totalprodprice').attr('prod-actual-price-withmoney');
      let productoriginalprice = $('.totalprodprice').attr('prod-price-check');
      prodpricewithmoney.split(''); 

      let discountedmoney = $('.bold-ro__frequency-div .bold-ro__unformatted-price').val()
      let newprice = prodpricewithmoney[0]+' '+ parseFloat(productoriginalprice*valueQTY).toFixed(2);
      let newprice2 = prodpricewithmoney[0]+' '+ parseFloat((discountedmoney/100)*valueQTY).toFixed(2);
      let priceshowonpage = '<span class="crossout">'+newprice+'</span><span class="newprice blue">'+newprice2+'</span>';
      $('.totalprodprice').html(priceshowonpage);   
    } 
    
      $('#RegisterForm').submit(function(e) {     
        if ( $('input[name="customer[password]"]').val() != $('input[name="customer[password_confirmation]"]').val()) {
          e.preventDefault();
          $( "#confirm-password" ).addClass( "dontMatch" );
           $(".dontMatchPassword").show();
         // alert('Passwords do not match.');
        }
      }); 

      let onloadSelectvalue = $('.product-form__variants option:selected').attr('data-valuere');
      $("input[name='option-0']").each(function(){
        if($(this).val() == onloadSelectvalue) {
          $(this).attr('checked', true);
        }
      });
      let colornamereonload = $("input[name='option-0']:checked").val();
      $('.colorNameRe').text(colornamereonload);
      if(colornamereonload != undefined) {
        $('li.product-single__thumbnails-item').each(function(){
          let strng = $(this).attr("data-color");
          if ( strng.includes(colornamereonload) ) {
            $(this).show();
          } else {
            $(this).hide();
          }
        }); 
      }
      $('.swatch :radio').change(function() { 
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $('.colorNameRe').text(optionValue);
        $('li.product-single__thumbnails-item').each(function(){
          let strng = $(this).attr("data-color");
          if ( strng.includes(optionValue) ) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change'); 
      });
      var selectCallback = function(variant, selector){
        // BEGIN SWATCHES
        if (variant && variant.available == true) {
          var form = $('#' + selector.domIdPrefix).closest('form');
          for (var i = 0, length = variant.options.length; i < length; i++) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
            if (radioButton.size()) {
              radioButton.get(0).checked = true;
            }
          }
        }
      };
      
      $('.slide-show-content-aboutUs').slick();
        $('[data-fancybox]').fancybox({
          youtube : {
              controls : 0,
              showinfo : 0
          },
          vimeo : {
              color : 'f00'
          }
      });

      $('.video-sort a').on('click',function(e){
        e.preventDefault();
        $('.video-sort a').each(function (){
          $(this).removeClass('active');
        });
        $(this).addClass('active');
        let toshowvideo = $(this).attr('data-filter');

        $('.productGrid').each(function() { 
          if(toshowvideo=='all') {
            $(this).removeClass('hide');
          } 
          if (toshowvideo=='freestanding') {
              if($(this).hasClass('freestanding')) {
                $(this).removeClass('hide');
              } else {
                $(this).addClass('hide');
              }
          } 
          if (toshowvideo=='countertop') {
            if($(this).hasClass('countertop')) {
              $(this).removeClass('hide');
            } else {
              $(this).addClass('hide');
            }
          } 
          if (toshowvideo=='tl') { 
            if($(this).hasClass('tl')) {
              $(this).removeClass('hide');
            } else {
              $(this).addClass('hide');
            }
          }
        if (toshowvideo=='bl') {
          if($(this).hasClass('bl')) {
            $(this).removeClass('hide');
          } else {
            $(this).addClass('hide');
          }
        }
        });

        $('.video-item').each(function() { 
          if(toshowvideo=='all') {
            $(this).removeClass('hide');
          } 
          if (toshowvideo=='bottled') {
              if($(this).hasClass('bottled')) {
                $(this).removeClass('hide');
              } else {
                $(this).addClass('hide');
              }
          } 
          if (toshowvideo=='bottleless') {
            if($(this).hasClass('bottleless')) {
              $(this).removeClass('hide');
            } else {
              $(this).addClass('hide');
            }
          } 
        });
      });

      $(".tabs-list li a").on('click',function(e){
        e.preventDefault();
     });
   
     $(".tabs-list li").on('click',function(){
        var tabid = $(this).find("a").attr("href");
        $(".tabs-list li,.tabs div.tab").removeClass("active");   // removing active class from tab
        $(".tab").hide();   // hiding open tab
        $(tabid).show();    // show tab
        $(this).addClass("active"); //  adding active class to clicked tab
   
     });

     $('.quickLearn').on('click', function(){
      $(this).find('.ql-icon').toggleClass('ql-icon-open').toggleClass('ql-icon-close');
      $(this).parent().find('.ql-desc-c').toggleClass('ql-desc-c-open').toggleClass('ql-desc-c-close');
    });

    $('.site-footer__item-inner p').on('click', function() {

      if($(window).width() < 767 ) { 
        $(this).toggleClass('active');
        $(this).next().toggleClass('active');
      }

    });

    $('.techspecs-button-1').on('click', function() {
      if($('.techspecs-section-spL-R-list').hasClass('active')) {
        $('.techspecs-button-1-text').text('view all tech specs');
        $('.techspecs-section-spL-R-list').removeClass('active');
      }else {
        $('.techspecs-button-1-text').text('hide all tech specs');
        $('.techspecs-section-spL-R-list').addClass('active');
      }
      
    });

    window.onscroll = function() {myFunction()};

    var header = document.getElementById("avalonHeader");
    var sticky = header.offsetTop;

    function myFunction() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }

    $('.exWarranty-btn-1').on('click', function(){
      if($('.exWarranty-btn-2').hasClass('active')){
        $('.exWarranty-btn-2').removeClass('active');
      }
      
      $(this).toggleClass('active'); 
      $('.extendedMess').toggleClass('openre');
      if($(this).hasClass('active')) {
        $('.extendedMess').addClass('openre');
      }
    });

    $('.exWarranty-btn-2').on('click', function(){
      if($('.exWarranty-btn-1').hasClass('active')){
        $('.exWarranty-btn-1').removeClass('active');
      }
     
      $(this).toggleClass('active'); 
      if($(this).hasClass('active')) {
        $('.extendedMess').addClass('openre');
      }
    });

    $('#increaseQTY').on('click', function(){
      let inputQTY = "#Quantity-product-template";
      let valueQTY = $(inputQTY).val();
      var valueCheck = parseInt(valueQTY,10);
      if(valueCheck != null || valueCheck != 'NaN' || valueCheck != '') {
        valueCheck= valueCheck +1;
        appendpricere(valueCheck);
      }
      $(inputQTY).val(valueCheck);
    }); 
    

    $('#decreaseQTY').on('click', function(){
      let inputQTY = "#Quantity-product-template";
      let valueQTY = $(inputQTY).val();
      var valueCheck = parseInt(valueQTY,10);
      if(valueCheck != null || valueCheck != 'NaN' || valueCheck != '' ) {
        if(valueCheck==1){
          valueCheck= valueCheck;
        } else {
          valueCheck= valueCheck -1;
          appendpricere(valueCheck);
        }
      }
      $(inputQTY).val(valueCheck);
    }); 

    function appendpricere (valueCheck){
      let valueQTY = valueCheck;
      let prodpricewithmoney = $('.totalprodprice').attr('prod-actual-price-withmoney');
      let productoriginalprice = $('.totalprodprice').attr('prod-price-check');
      prodpricewithmoney.split(''); 

      let discountedmoney = $('.bold-ro__frequency-div .bold-ro__unformatted-price').val()

      if($('.bold-ro__bold-active').length > 0) {
        if($(".bold-ro__bold-active input[name='bold-ro__selector_radio_button']").hasClass('bold-ro__one-time-radio-btn')) {
          let newprice = prodpricewithmoney[0]+' '+ parseFloat(productoriginalprice*valueQTY).toFixed(2);
          $('.totalprodprice').html(newprice);
       } 
       if($(".bold-ro__bold-active input[name='bold-ro__selector_radio_button']").hasClass('bold-ro__subscribe-radio-btn')) {
          let newprice = prodpricewithmoney[0]+' '+ parseFloat(productoriginalprice*valueQTY).toFixed(2);
          let newprice2 = prodpricewithmoney[0]+' '+ parseFloat((discountedmoney/100)*valueQTY).toFixed(2);
          let priceshowonpage = '<span class="crossout">'+newprice+'</span><span class="newprice blue">'+newprice2+'</span>';
          $('.totalprodprice').html(priceshowonpage);   
       } 
      } else{
        let newpricenonsub = prodpricewithmoney[0]+' '+ parseFloat(productoriginalprice*valueCheck).toFixed(2);
        $('.totalprodprice').html(newpricenonsub);
      }
    }
    
    $(document).on('click', '.bold-ro__radio-div', function(){
        let inputQTY = "#Quantity-product-template";
        let valueQTY = $(inputQTY).val();
        let productoriginalprice = $('.totalprodprice').attr('prod-price-check');

        let prodpricewithmoney = $('.totalprodprice').attr('prod-actual-price-withmoney');
        prodpricewithmoney.split('');

        let discountedmoney = $('.bold-ro__frequency-div .bold-ro__unformatted-price').val();

        if($(this).find('input').hasClass('bold-ro__one-time-radio-btn')) {
            let newprice = prodpricewithmoney[0]+' '+ parseFloat(productoriginalprice*valueQTY).toFixed(2);
            $('.totalprodprice').html(newprice);
        }
        if($(this).find('input').hasClass('bold-ro__subscribe-radio-btn')) {
            let newprice = prodpricewithmoney[0]+' '+ parseFloat(productoriginalprice*valueQTY).toFixed(2);
            let newprice2 = prodpricewithmoney[0]+' '+ parseFloat((discountedmoney/100)*valueQTY).toFixed(2);
            let priceshowonpage = '<span class="crossout">'+newprice+'</span><span class="newprice blue">'+newprice2+'</span>';
            $('.totalprodprice').html(priceshowonpage);   
        }
    });
    
    $(".sendclick").click(function(e) {
      e.preventDefault();
      var name = $("#last_name").val();
      var email = $("#email").val();
      var company = $("#company").val();
      var phone = $("#phone").val();
      var description = $("#description").val();
      if (!(name == '' || email == '' || company == ''  || phone == ''  || description == '')) {
        $("#messagesubmit").show();
        setTimeout(function(){ 
          $("#messagesubmit").hide();
          $('.send').click(); 
        }, 3000);
      } else {
        alert("Please Fill All Fields.");
      } 
    });

      $('.menu-overlay').attr('style', 'top: '+$('#avalonHeader').height()+'px;');
      $('.site-header__icon.site-header__cart').on('click', function(e){
          e.preventDefault();
          $('.menu-cart').toggleClass('active');
          $('.menu-overlay').toggleClass('cart-active');
          // setTimeout ( function(){
          //   $('.menu-cart').removeClass('active');
          //   $('.menu-overlay').removeClass('cart-active');
          // }, 5000);
      });

      $('.menu-cart-closeBtn').on('click', function(e){
        e.preventDefault();
        $('.menu-cart').removeClass('active');
        $('.menu-overlay').removeClass('cart-active');
      });

      $('.gridswatch').on('click', function(){
        let colorname = $(this).attr('colorname');
        if(!$(this).hasClass('active')) {
          $(this).addClass('active');
          $(this).siblings().removeClass('active');
        }
        let imagesection = '.'+$(this).closest('.product-form__swatch').attr('id')+' img.variantimage';
        $(imagesection).each(function() {
          if($(this).attr('imageid') == colorname ) {
              $(this).addClass('active');
          } else {
              if($(this).hasClass('active')){
                $(this).removeClass('active');
              }
          }
        });
      });
           
      $('#mobilesort').on('click', function(){
        $(this).toggleClass('active');
        $('.mobilefilter').toggleClass('active');
      });

      $(window).load(function(){
        if ($('.pr-snippet-rating-decimal').text() == '0.0') {
          $('#pwr-snippets').hide();
          $('#pr-review-display').attr('style', 'width: 100%;'); 
        }
      });

    }); 
    /* eslint-enable */ 
  }
})($); 